import { Route, Redirect } from "react-router-dom";
//import { useContext } from "react";
import { useAuth } from "../contexts/AuthContext";

const PrivateRoute = ({ children, ...rest }) => {
  //let { user } = useContext(AuthContext);
  let auth = useAuth();
  return <Route {...rest}>{!auth.user ? <Redirect to='/login' /> : children}</Route>;
};

export default PrivateRoute;
